// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__38bCp","insightsList":"newBusinessInsightsMenu_insightsList__SQvmx","active":"newBusinessInsightsMenu_active__1_ME7"};